<script>
    import { onMount, createEventDispatcher } from 'svelte';
    // import { Link, navigate } from 'svelte-routing'
    import { Link, navigateTo } from 'yrv';


    import axios from 'axios'
    import wait from '../../libs/wait';

    import FadeinFX from '../../components/FX/FadeinFx.svelte';
    import SlideinFX from '../../components/FX/SlideinFX.svelte';
    import AdminLayout from '../../layouts/AdminLayout.svelte';
    import Header from '../../components/Header/Header.svelte';
    import DashboardButton from '../Dashboard/DashboardButton.svelte';
    import TouchIcon from '../../components/TouchIcon/TouchIcon.svelte';
    import userStore from '../../stores/user'
    import storage from '../../libs/storage'

    
    const dispatch = createEventDispatcher ();
    
    let screenReady = false
    let screenVisible = true
    let model = null

    onMount (() => {
        storage.remove ('sector');
        userStore.setSector (null);

        dispatch ('app-event', { id: 'background', value: true });
        screenReady = true
        axios.get ('/api/categories/olist')
            .then (result => {
                model = result.data.categories;
                dispatch ('app-event', { id: 'background', value: false });
                screenReady = true
            }).catch (e => {
                dispatch ('app-event', { id: 'app-error', error: e });
                screenReady = true    
            })
    });

    const chooseSector = (id) => {
        const sector = model.filter (it => it.id === id)[0]
        console.log ('sector', sector)
        userStore.setSector (sector);
        storage.set ('sector', sector);
        navigateTo ('/app/programs/' + id)
        // wait (200).then (() => navigate ('/dashboard/' + id))
    }
</script>


<AdminLayout>
    <div class="page-pad avoid-selection">
        
        {#if screenReady && screenVisible}
            <SlideinFX delayOut={300}>
                <div class="welcome-text">
                    Ciao, <div>{$userStore.name}</div>
                </div>
            </SlideinFX>
            <FadeinFX delay={300} delayOut={0}>
                <div class="clearfix">
                    {#if model}
                        {#each model as sector (sector.id)}
                            <DashboardButton icon="fad {sector.icon}" 
                                label={sector.name} 
                                click={event => chooseSector (sector.id)} 
                                description={sector.description ? sector.description : '--'} 
                                index={sector.color} />
                        {/each}
                    {/if}
                </div>
                <!-- <button on:click={() => { userStore.setName ('Pinco Pallino') }}>test</button> -->
            </FadeinFX>
        {/if}
    </div>
</AdminLayout>


<style>
    .welcome-text {
        width: 80%;
        font-size: 24px;
        font-weight: 600;
        -webkit-animation-duration: .2s;
        animation-duration: .2s;
        margin-bottom: 25px;
        line-height: 26px;
    }
    .welcome-text > :global(div) {
        color: #71a4b5;
        text-transform: capitalize;
    }
</style>